/** 英文 */
export default {
    "年龄": "Age",
    submit: "Submit",
    example: {
        name: "ZhangSan"
    },
    "欢迎使用交换机云平台": "Welcome to the Switch Cloud Platform",
    "请输入手机号或邮箱": "Please enter your phone number or email address",
    "请输入密码(6~12位字母+数字)": "Please enter password (6-12 letters+numbers)",
    "登录": "Login",
    "登录中": "Logging in",
    "自动登录": "Auto-login",
    "忘记密码": "Forgot password",
    "请输入手机号": "Please enter your phone number",
    "请输入验证码": "Please enter the verification code",
    "请输入邮箱": "Please enter your email",
    "没有账号，": "No account,",
    "去注册": "Go to register",
    "密码登录": "Password login",
    "手机号验证": "Mobile number verification",
    "邮箱验证": "Email verification",
    "请正确输入手机号或邮箱": "Please enter your phone number or email correctly",
    "请输入正确的密码(6~12位字母+数字)": "Please enter the correct password (6-12 letters+numbers)",
    "登录成功！": "Login successful!",
    "登录失败": "Login failed",
    "手机号格式不正确": "The format of the phone number is incorrect",
    "邮箱格式不正确": "Email format incorrect",
    "返回登录": "Back to login",
    "确认": "Confirm",
    "请输入密码": "Please enter password",
    "确认中": "Confirming",
    "重置密码成功": "Password reset successful",
    "忘记密码失败": "Forgot password failed",
    "注册账号": "Register account",
    "请选择": "Please select",
    "请输入邀请码(必填)": "Please enter invitation code (required)",
    "注册": "Register",
    "注册中": "Registering",
    "已阅读并同意": "Read and agreed to",
    "《用户注册协议》": "User Registration Agreement",
    "与": "and",
    "《隐私政策》": "Privacy Policy",
    "用户协议": "User Agreement",
    "隐私协议": "Privacy Agreement",
    "普通用户": "Regular User",
    "工程商": "Contractor",
    "代理商": "Agent",
    "请输入邀请码（必填）": "Please enter invitation code (required)",
    "请查看并勾选用户协议": "Please check and agree to the User Agreement",
    "注册成功！": "Registration successful!",
    "注册失败": "Registration failed",

    "获取验证码": "Get verification code",
    "手机号输入错误请重新输入": "Incorrect phone number, please re-enter",
    "邮箱输入错误请重新输入": "Incorrect email, please re-enter",
    "重新获取": "Resend",
    "验证码发送成功": "Verification code sent successfully",
    "失败": "Failed",

    "概览": "Overview",
    "项目": "Projects",
    "设备": "Devices",
    "维护": "Maintenance",
    "个人设置": "Personal Settings",
    "退出登录": "Logout",
    "确定退出系统吗？": "Are you sure you want to exit the system？",
    "提示": "Prompt",
    "取消": "Cancel",
    "基本设置": "Basic Settings",
    "安全设置": "Safe Settings",

    "姓名/昵称": "Name/Nickname",
    "请输入": "Please enter",
    "手机": "Phone",
    "电子邮件": "Email",
    "性别": "Gender",
    "保密": "Private",
    "男": "Male",
    "女": "Female",
    "保存": "Save",
    "请上传头像": "Please upload avatar",
    "请输入姓名/昵称": "Please enter name/nickname",

    "无": "None",
    "账号密码": "Account Password",
    "用于保护帐号信息和登录安全": "Used to protect account information and login security",
    "修改": "Modify",
    "绑定手机号": "Bind Phone Number",
    "绑定邮箱": "Bind Email",

    "修改密码": "Modify Password",
    "原密码验证": "Verify Original Password",

    "返回": "Back",
    "原密码": "Current Password",
    "请输入原密码": "Please enter current password",
    "新密码": "New Password",
    "请输入新密码": "Please enter new password",
    "确认密码": "Confirm Password",
    "请再次输入新密码": "Please re-enter new password",
    "请输入旧密码": "Please enter old password",
    "请输入旧密码（6~12位字母+数字）": "Please enter old password (6-12 characters, letters and numbers)",
    "请输入新密码（6~12位字母+数字）": "Please enter new password (6-12 characters, letters and numbers)",
    "请再次输入新密码（6~12位字母+数字）": "Please re-enter new password (6-12 characters, letters and numbers)",
    "两次输入密码不一致": "Passwords do not match",
    "成功": "Success",

    "手机号": "Phone Number",
    "验证码": "Verification Code",
    "密码": "Password",
    "请输入正确的验证码": "Please enter the correct verification code",
    "邮箱": "Email",
    "换绑手机号": "Change the bound phone number",
    "设置": "Settings",
    "绑定": "Bind",
    "原手机号": "Original phone number",
    "下一步": "Next step",
    "新手机号": "New phone number",
    "请输入新手机号": "Please enter the new phone number",
    "更新成功": "Update successful",
    "换绑邮箱": "Change the bound email address",
    "请输入正确的邮箱": "Please enter a valid email address",
    "绑定成功": "Bound successfully",
    "请输入密码（6~12位字母+数字）": "Please enter a password (6-12 letters and numbers)",
    "请输入正确的手机号": "Please enter a valid phone number",
    "原邮箱": "Original email",
    "请输入原邮箱": "Please enter the original email",
    "请输入新邮箱": "Please enter the new email address",

    "订阅消息类型": "Subscription Message Type",
    "配置异常": "Configuration Exception",
    "设备异常": "Device Exception",
    "网络安全": "Network Security",
    "接入异常": "Access Exception",
    "设备上线/掉线": "Device Online/Offline",
    "其他异常": "Other Exceptions",
    "系统升级": "System Upgrade",
    "配置操作": "Configuration Operation",
    "射频调优": "RF Optimization",
    "端口异常": "Port Exception",
    "终端异常": "Terminal Exception",
    "订阅项目": "Subscription Items",
    "请选择要订阅的项目": "Please select the items to subscribe",
    "告警接收人邮箱": "Alarm Recipient Email",

    "告警": "Alert",
    "告警记录": "Alert Records",
    "告警设置": "Alert Settings",

    "全部": "All",
    "未读": "Unread",
    "已读": "Read",
    "项目名称：": "Project Name:",
    "设备类型：": "Device Type:",
    "设备SN：": "Serial Number:",
    "搜索": "Search",
    "重置": "Reset",
    "一键已读": "Mark All as Read",
    "项目名称": "Project Name",
    "设备类型": "Device Type",
    "设备名称": "Device Name",
    "设备SN": "Serial Number",
    "管理IP": "Management IP",
    "告警类型": "Alert Type",
    "告警级别": "Alert Level",
    "告警内容": "Alert Content",
    "告警时间": "Alert Time",
    "告警读取时间": "Alert Read Time",

    "项目概览": "Project Overview",
    "设备概览": "Device Overview",
    "告警概览": "Alert Overview",
    "项目搜索": "Project Search",
    "创建项目": "Create Project",
    "我的项目": "My Projects",
    "查看更多": "View More",
    "交换机": "Switch",
    "智能箱": "Smart Box",
    "操作": "Actions",
    "导出报告": "Export Report",
    "导出设备": "Export Devices",
    "进入项目": "Enter Project",
    "我的接收": "My Receiving",

    "请输入项目名称": "Please enter project name",
    "请输入设备类型": "Please enter device type",
    "请输入设备SN": "Please enter serial number",
    "请输入MAC地址": "Please enter MAC address",
    "软件版本": "Software Version",
    "更新时间": "Update Time",
    "状态": "Status",

    "网络拓扑": "Network Topology",
    "地图定位": "Map Location",
    "设备详情": "Device Details",
    "端口详情": "Port Details",
    "标注端口状态": "Mark Port Status",
    "设备监控": "Device Monitoring",
    "设备配置": "Device Configuration",

    "刷新": "Refresh",
    "整网重启": "Network-wide Restart",
    "整网升级": "Network-wide Upgrade",
    "配置VLAN": "Configure VLAN",
    "端口": "Port",

    "添加": "Add",
    "批量开启": "Batch Enable",
    "批量关闭": "Batch Disable",
    "删除": "Delete",
    "无数据": "No Data",
    "端口列表": "Port List",
    "全选端口": "Select All Ports",
    "取消全选": "Deselect All",
    "端口选择：": "Port Selection:",
    "是否已设置": "Configured",
    "取消隔离": "Cancel Isolation",
    "聚合号": "Aggregation ID",
    "请输入端口聚合号": "Please enter port aggregation ID",
    "编辑": "Edit",
    "广播": "Broadcast",
    "未知名组播": "Unknown Multicast",
    "未知名单播": "Unknown Unicast",
    "端口：": "Port:",
    "输入限速：": "Ingress Rate Limit:",
    "输出限速：": "Egress Rate Limit:",
    "是": "Yes",
    "否": "No",
    "输入限速": "Ingress Rate Limit",
    "输出限速": "Egress Rate Limit",
    "PoE全局信息": "PoE Global Info",
    "更新时间：": "Update Time:",
    "总功率": "Total Power",
    "实时功率": "Real-time Power",
    "PoE端口列表": "PoE Port List",
    "链接状态": "Link Status",
    "端口电源": "Port Power",
    "电压": "Voltage",
    "电压（V）": "Voltage (V)",
    "电流": "Current",
    "电流（mA）": "Current (mA)",
    "功率": "Power",
    "优先级": "Priority",
    "收发器状态": "Transceiver Status",
    "温度（℃）": "Temperature (°C)",
    "接收功率（dBm）": "Rx Power (dBm)",
    "发送功率（dBm）": "Tx Power (dBm)",
    "检测结果": "Test Result",
    "检测时间": "Test Time",
    "开始检测": "Start Test",
    "上行速率（Mbps）": "Uplink Rate (Mbps)",
    "下行速率（Mbps）": "Downlink Rate (Mbps)",
    "VLAN配置": "VLAN Configuration",
    "选择设备": "Select Device",
    "请选择选择设备": "Please select device",
    "请输入2～4094间的数值": "Please enter value between 2-4094",
    "名称": "Name",
    "请输入1～12个字符": "Please enter 1-12 characters",
    "模式": "Mode",
    "请选择VLAN模式": "Please select VLAN mode",
    "说明：端口图标中的数字为PVID，此类端口为上联口": "The number in the port icon is PVID. These ports are uplink ports.",
    "相同汇聚组LAG的端口，只能同时为Untagged或Tagged": "Ports in the same LAG group can only be Untagged or Tagged together.",
    "上联口速率(Mbps)": "Uplink Port Rate (Mbps)",
    "上行速率": "Uplink Rate",
    "下行速率": "Downlink Rate",
    "端口速度": "Port Speed",
    "设备状态": "Device Status",
    "添加设备": "Add Device",
    "EWEB": "EWEB",
    "重启": "Restart",
    "升级": "Upgrade",
    "时间同步": "Time Sync",
    "解绑": "Unbind",
    "分组": "Group",
    "设备型号": "Device Model",
    "所属项目": "Project",
    "请选择项目": "Please select project",
    "所属分组": "Group",
    "请选择分组": "Please select group",
    "添加分组": "Add Group",
    "设备SN码": "Device SN",
    "请选择设备SN码": "Please select device SN",
    "vlan名称": "VLAN Name",
    "角色": "Role",
    "删除项目": "Delete Project",
    "批量配置": "Config",
    "VLAN名称": "VLAN Name",
    "TAGGED端口": "TAGGED Port",
    "UNTAGGED端口": "UNTAGGED Port",
    "项目分组": "Project Group",
    "序号": "No.",
    "项目名": "Project Name",
    "分组名": "Group Name",
    "使用": "Use",
    "操作日志": "Operation Log",
    "用户名": "Username",
    "操作类型": "Operation Type",
    "操作对象": "Operation Object",
    "操作结果": "Operation Result",
    "时间": "Time",
    "开始时间": "Start Time",
    "结束时间": "End Time",
    "备注": "Remark",
    "成员管理": "Member Management",
    "共享项目": "Share Project",
    "删除成员": "Remove Member",
    "权限": "Permission",
    "定时升级": "Scheduled Upgrade",
    "是否开启": "Enable",
    "设备将在设定时间自动升级": "Devices will upgrade automatically at the scheduled time",
    "添加时间": "Add Time",
    "升级时间": "Upgrade Time",
    "请选择时间": "Please select time",
    "设备将在设定时间以后自动升级": "Devices will upgrade automatically after the scheduled time",
    "立即升级": "Upgrade Now",
    "请选择要升级的设备类型": "Please select device type to upgrade",
    "开启": "On",
    "关闭": "Off",
    "定时重启": "Scheduled Restart",
    "重启时间": "Restart Time",
    "后": "after",
    "设备将在设定时间以后自动重启": "Devices will restart automatically after the scheduled time",
    "立即重启": "Restart Now",
    "请选择要重启的设备类型": "Please select device type to restart",
    "请输入分组名": "Please enter group name",
    "账号": "Account",
    "地图选点": "Map Location",
    "无项目": "No Projects",
    "我的分享": "My Shares",
    "项目管理": "Project Management",
    "托管": "Managed",
    "共享": "Shared",
    "管理员": "Administrator",
    "AP": "AP",
    "AC": "AC",
    "移交项目": "Transfer Project",
    "创建企业": "Create Enterprise",
    "删除企业": "Delete Enterprise",
    "企业名称": "Enterprise Name",
    "项目数量": "Project Count",
    "无设备信息": "No Device Info",
    "请选择设备类型": "Please select device type",
    "请选择设备SN": "Please select device SN",
    "未搜索到项目": "No projects found",
    "你好": "Hello",

    "设备告警记录": "Device Alert Records",
    "项目信息": "Project Info",
    "项目MAP": "Project MAP",
    "角色名称": "Role Name",
    "角色权限": "Role Permission",
    "成员信息": "Member Info",
    "编辑报告信息": "Edit Report Info",
    "报告名称": "Report Name",
    "项目负责人": "Project Manager",
    "联系电话": "Contact Phone",
    "交付日期": "Delivery Date",
    "年/月/日": "YYYY/MM/DD",
    "确认导出": "Confirm Export",
    "企业信息": "Enterprise Info",
    "用户角色": "User Role",
    "搜索关键词": "Search Keyword",
    "确定": "OK",
    "安卓端": "Android",
    "IOS端": "IOS",
    "已选中X个端口": "X ports selected",
    "请选择设备型号": "Please select device model",
    "出口速率": "Egress Rate",
    "入口速率": "Ingress Rate",
    "留空或0表示不限速": "Leave empty or 0 for unlimited",
    "端口速率双工": "Port Speed/Duplex",
    "角色信息": "Role Info",
    "请输入用户手机号/邮箱": "Please enter phone/email",
    "请选择角色": "Please select role",
    "当前设备软件均为最新版本，无需升级": "All devices are running the latest version",
    "知道了": "Got it",
    "端口限速": "Port Rate Limit",
    "端口隔离": "Port Isolation",
    "风暴控制": "Storm Control",
    "静态LACP": "Static LACP",
    "线缆检测": "Cable Test",
    "DDM信息": "DDM Info",
    "PoE信息": "PoE Info",
    "上联口": "Uplink Port",
    "端口开关": "Port Switch",
    "端口速率/双工：自协商": "Port Speed/Duplex: Auto",
    "入口速率(Mbps)：不限速": "Ingress Rate (Mbps): Unlimited",
    "出口速率(Mbps)：不限速": "Egress Rate (Mbps): Unlimited",
    "近24小时": "Last 24 Hours",
    "项目体验": "Project Experience",
    "APP下载": "App Download",
    "快速添加": "Quick Add",
    "快速解绑": "Quick Unbind",
    "快速查找": "Quick Search",
    "企业管理": "Enterprise Management",
    "搜索结果": "Search Results",
    "系统消息": "System Message",
    "详情": "Details",
    "端口信息": "Port Info",
    "未连接": "Disconnected",
    "电口": "Copper Port",
    "光口": "Fiber Port",
    "聚合口": "Aggregation Port",
    "POE供电": "PoE Powered",
    "供电异常": "Power Exception",
    "阻塞口": "Blocked Port",
    "无线AC": "Wireless AC",
    "无线AP": "Wireless AP",
    "网桥": "Bridge",
    "出口路由器": "Gateway Router",
    "电脑": "PC",
    "打印机": "Printer",
    "摄像机": "Camera",
    "服务器": "Server",
    "光纤收发器": "Media Converter",
    "在线": "Online",
    "离线": "Offline",

    "保存成功": "Saved successfully",
    "是否删除该vlan？": "Delete this VLAN?",
    "是否要删除选中的vlan？": "Delete selected VLANs?",
    "请选择要删除的vlan": "Please select VLANs to delete",
    "删除成功": "Deleted successfully",
    "是否删除该端口限速？": "Delete this port rate limit?",
    "请输入输入限速": "Please enter ingress rate limit",
    "请输入输出限速": "Please enter egress rate limit",

    "项目添加成功": "The item has been successfully added",
    "项目编辑成功": "The project has been edited successfully",
    "端口速率(Mbps)": "Port speed (Mbps)",
    "上行速度": "Upload speed",
    "端口速率/双工：": "Port speed/duplex:",
    "入口速率(Mbps)：": "Ingress rate (Mbps):",
    "不限速": "Speed unlimited",
    "出口速率(Mbps)：": "Export rate (Mbps):",
    "备注：": "Note:",
    "端口速率双工：": "Port speed and duplex:",
    "已取消操作": "Operation canceled",
    "上行": "Upstream",
    "下行": "Downward",
    "端口备注": "Port remark",
    "PoE开关": "PoE switch",
    "PoE看门狗": "PoE watchdog",
    "下发成功": "Successfully delivered",
    "说明：端口图标中的数字为PVID，": "Note: The number in the port icon represents PVID,",
    "此类端口为上联口": "This type of port is an uplink port",
    "端口模式配置": "Port mode config",
    "注：端口若为上行接口，修改vlan模式配置，会存在设备和服务端网络中断的风险": "Note: If the port is an upstream interface, modifying the VLAN mode configuration may pose a risk of network interruption between the device and the server",
    "vlan模式": "Vlan mode",

    "监控": "Monitor",
    "配置": "Config",
    "端口统计": "Port statistics",
    "历史报警/消息": "Historical alarms/messages",
    "标注端口连接设备": "Label port connection device",
    "端口监测到回环后会自动被阻塞，防止环路": "Ports will be automatically blocked after detecting loopback to prevent loops",
    "环回保护": "loopback protection",
    "展开端口展示": "Expand port display",
    "收起端口展示": "Hide port display",
    "近1小时": "Nearly 1 hour",
    "近12小时": "Nearly 12 hour",
    "近7天": "Nearly 7 day",
    "端口状态": "Port status",
    "连接设备类型标注": "Labeling of connected device types",
    "项目类型": "Project type",
    "更多": "More",
    "请选择设备": "Please select device",
    "请输入VLAN ID": "Please enter VLAN ID",
    "请输入VLAN ID（2～4094间的数值）": "Please enter the VLAN ID (a value between 2 and 4094)",
    "请输入VLAN名称": "Please enter VLAN name",
    "是否解绑该设备？": "Unbind this device?",
    "创建项目功能": "Create project function",
    "添加角色功能": "Add role function",
    "导出报告功能": "Export report function",
    "导出设备功能": "Export device function",
    "进入项目功能": "Enter project function",
    "编辑企业功能": "Edit enterprise functions",
    "请选择要重启的设备": "Please select have restart device",
    "请选择要升级的设备": "Please select have update device",
    "请选择要时间同步的设备": "Please select the device for time synchronization",
    "请选择要解绑的设备": "Please select the device you want to unbind",
    "内存": "Memory",
    "端口选择": "Port select",
    "一般": "General",
    "中等": "Moderate",
    "严重": "Serious",
    "请检查表单信息是否正确": "Please check if the form information is correct",
    "报告导出成功": "Report exported successfully",
    "请选择企业": "Please select a company",
    "请输入项目MAP": "Please enter the project MAP",
    "请选择项目坐标": "Please select the project coordinates",
    "请选择要删除的项目": "Please select the item(s) to be deleted",
    "请先选择要删除的分组": "Please select the group to be deleted first",
    "是否要删除该分组": "Do you want to delete this group",
    "请选择要删除的成员": "Please select the member(s) to be deleted",
    "是否要删除选中的成员？": "Do you want to delete the selected members?",
    "是否要删除该的成员？": "Do you want to delete the member of this?",
    "请输入企业名称": "Please enter the name of the enterprise",
    "请选择要删除的企业": "Please select the enterprise to be deleted",
    "是否要删除选中的企业？": "Do you want to delete the selected enterprise?",
    "企业删除成功": "The enterprise has been successfully deleted",
    "企业删除失败": "The enterprise deletion failed",
    "改变成功": "Change success",
    "是否要删除该定时？": "Do you want to delete this timer?",
    "配置成功": "Configuration successful",
    "不可对同一端口同时进行Untagged和Tagged操作": "Untagged and tagged operations cannot be performed simultaneously on the same port",
    "access模式不可编辑Tagged": "The access mode is not editable for Tagged",
    "确认重启设备？": "Confirm to restart the device?",
    "是否重启选中的设备？": "Do you want to restart the selected device?",
    "重启成功": "Restart successful",
    "是否升级选中的设备？": "Do you want to upgrade the selected device?",
    "升级成功": "Upgrade successful",
    "是否时间同步选中的设备？": "Should the selected devices be synchronized with the time?",
    "时间同步成功": "Time synchronization successful",
    "是否解绑选中的设备？": "Unbind the selected device?",
    "解绑成功": "Unbound successfully",
    "是否取消该端口隔离？": "Should the port isolation be cancelled?",
    "请选择要隔离的端口": "Please select the port to be isolated",
    "是否删除该端口风暴控制？": "Should we delete the port storm control?",
    "请选择要风暴控制的端口": "Please select the port for storm control",
    "请输入广播": "Please enter the broadcast",
    "请输入未知名组播": "Please enter the unknown multicast",
    "请输入未知名单播": "Please enter the unknown unicast",
    "是否删除该静态LACP？": "Should this static LACP be deleted?",
    "请选择要静态LACP的端口": "Please select the ports for static LACP",
    "确认升级设备？": "Confirm to upgrade the device?",
    "下发升级成功": "Upgrade issued successfully",
    "xxx设备已是最新版本": "The {name} device is already at the latest version",
    "是否要删除选中的项目？": "Do you want to delete the selected items?",
    "项目删除成功": "The item has been successfully deleted",
    "项目删除失败": "The deletion of the item failed",
    "无项目id": "No project ID",
    "设备信息": "Device Information",
    "是否要删除选中的分组": "Do you want to delete the selected group",
    "请输入设备SN码": "Please enter device sn code",
    "成员删除失败": "Member deletion failed",
    "编辑成功": "Edit success",
    "企业添加成功": "The enterprise has been successfully added",
    "请输入备注": "Please enter note",
    "端口X为上行接口，如修改上行接口的vlan模式配置，会存在设备和服务端网络中断的风险，请谨慎操作！！！": "Port {name} is an upstream interface. If you modify the VLAN mode configuration of the upstream interface, there is a risk of network interruption between the device and the server. Please proceed with caution!!!",
    "输入限速(Mbps)：": "Input speed limit (Mbps):",
    "输出限速(Mbps)：": "Output speed limit (Mbps):",
    "该端口不支持PoE": "This port does not support PoE",
    "编辑名称": "Edit name",
    "批量编辑": "Batch edit",
    "请选择要取消隔离的端口": "Please select the port to be unquarantined",
    "是否取消选中的端口隔离？": "Do you want to cancel the selected port isolation?",
    "取消成功": "Cancel success",
    "该端口已设置隔离": "This port has been set with isolation",
    "聚合组": "Aggregation group",
    "端口模式不匹配，不可编辑": "Port mode mismatch, cannot be edited",
}
